var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('common-title', {
    attrs: {
      "title": "我们的合作伙伴",
      "padding": "100,0"
    }
  }, _vm._l(_vm.logoList, function (item, index) {
    return _c('vue-seamless-scroll', {
      key: index,
      class: index == 1 ? 'scroll-item' : '',
      staticStyle: {
        "overflow": "hidden"
      },
      attrs: {
        "data": item.logos,
        "class-option": item.classOption
      }
    }, [_c('ul', {
      staticClass: "flexs w-001"
    }, _vm._l(item.logos, function (logo) {
      return _c('li', {
        key: logo.id,
        staticClass: "logo-item"
      }, [_c('img', {
        staticClass: "img86 radius-10",
        attrs: {
          "src": _vm.getImagePath(logo.src)
        }
      })]);
    }), 0)]);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };